import { render, staticRenderFns } from "./LeftCall.vue?vue&type=template&id=575a3c61&scoped=true&"
import script from "./LeftCall.vue?vue&type=script&lang=js&"
export * from "./LeftCall.vue?vue&type=script&lang=js&"
import style0 from "./LeftCall.vue?vue&type=style&index=0&id=575a3c61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575a3c61",
  null
  
)

export default component.exports